import React from "react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/5 py-14"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div>
                    <div className="font-serif-display italic text-2xl text-[#f4f4f0]">
                        Viktor Varek
                    </div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mt-1">
                        Live by your code
                    </div>
                </div>
                <div className="flex flex-wrap gap-8 text-[11px] tracking-[0.24em] uppercase text-neutral-500">
                    <a
                        href="#phases"
                        className="hover:text-[#f4f4f0] transition-colors"
                    >
                        Phases
                    </a>
                    <a
                        href="#manifesto"
                        className="hover:text-[#f4f4f0] transition-colors"
                    >
                        Manifesto
                    </a>
                    <a
                        href="#author"
                        className="hover:text-[#f4f4f0] transition-colors"
                    >
                        The Author
                    </a>
                    <a
                        href="#pricing"
                        className="hover:text-[#f4f4f0] transition-colors"
                    >
                        Acquire
                    </a>
                    <a
                        href="#faq"
                        className="hover:text-[#f4f4f0] transition-colors"
                    >
                        FAQ
                    </a>
                </div>
                <div className="text-[10px] tracking-[0.24em] uppercase text-neutral-600">
                    © {new Date().getFullYear()} · Varek Editions
                </div>
            </div>
        </footer>
    );
}
